import { ILoginOIDCRequest } from "../../../model/request/auth/ILoginOIDCRequest";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { ILoginError, ILoginStart, ILoginSuccess, eLoginActions } from "../../action-types/auth/ILoginActions";
import { baseAction } from "../IActionBase";

export const loginActions = {
    loginStart: (payload: ILoginOIDCRequest): ILoginStart => baseAction(eLoginActions.LOGIN_START, payload),
    loginSuccess: (data: ILoginRespone): ILoginSuccess => {
        localStorage.setItem("access_token", data.token_info.access_token)
        localStorage.setItem("refresh_token", data.token_info.refresh_token)
        return baseAction(eLoginActions.LOGIN_SUCCESS, data)
    },
    loginError: (message?: string): ILoginError => {
        return baseAction(eLoginActions.LOGIN_ERROR, message)
    },
  
}